<template>
  <cms-modal2 unique="view-pandi" title="View P&I" size="xl" :screen-height="true">
    <div class="row no-gutters text-small">
      <div class="col-12 col-lg-6">
        <form @submit.prevent="confirmUpdatePandi" class="overflow-auto" style="height: 80vh;" id="pandi-field">
          <div class="form-group form-row mb-1 w-100">
            <label for="pni-code" class="col-4 col-form-label pt-0 font-weight-bold">P & I Case :</label>
            <div class="col-3">
              <input type="text" id="pni-code"
                     class="form-control form-control-sm form-control-xs"
                     placeholder="P&I Code"
                     :readonly="!editable"
                     v-model="pandi.code"
              >
            </div>
            <label for="pni-days" class="col-3 col-form-label pt-0 text-right font-weight-bold">Total Days :</label>
            <div class="col-2">
              <input type="text" id="pni-days" readonly
                     class="form-control form-control-sm form-control-xs px-lg-0 px-xl-2 text-center"
                     placeholder="0"
                     :value="totalDays"
              >
            </div>
          </div>

          <div class="form-group form-row mb-1 w-100">
            <label for="pni-vessel" class="col-4 col-form-label pt-0 font-weight-bold">Vessel :</label>
            <div class="col-8">
              <input type="text" readonly id="pni-vessel" class="form-control form-control-sm"
                     :value="pandi.vessel"
              >
            </div>
          </div>

          <div class="form-group form-row mb-1 w-100">
            <label for="pni-diagnosis" class="col-4 col-form-label pt-0 font-weight-bold">Diagnosis :</label>
            <div class="col-8">
                          <textarea class="form-control form-control-sm" id="pni-diagnosis" rows="5" readonly
                                    style="resize: none"
                                    v-model="pandi.diagnosis"
                          ></textarea>
            </div>
          </div>

          <div class="form-group form-row mb-1 w-100">
            <label for="pni-arrival" class="col-4 col-form-label pt-0 font-weight-bold">Arrival in Manila :</label>
            <div class="col-8">
              <input type="text" id="pni-arrival" readonly
                     class="form-control form-control-sm"
                     placeholder="Arrival Date"
                     :value="pandi.arrivalDate"
              >
            </div>
          </div>

          <div class="form-group form-row mb-1 w-100">
            <label for="pni-finish-contract" class="col-4 col-form-label pt-0 font-weight-bold">Finished Contract
              :</label>
            <div class="col-8">
              <select class="form-control form-control-sm" id="pni-finish-contract"
                      :disabled="!editable"
                      v-model="pandi.finish_contract"
              >
                <option :value="null">---Select---</option>
                <option :value="1">YES</option>
                <option :value="2">NO</option>
              </select>
            </div>
          </div>

          <div class="form-group form-row mb-1 w-100">
            <label for="pni-discharge" class="col-4 col-form-label pt-0 font-weight-bold">Vessel Deviation to Discharge
              :</label>
            <div class="col-8">
              <select class="form-control form-control-sm" id="pni-discharge"
                      :disabled="!editable"
                      v-model="pandi.discharge"
              >
                <option :value="null">---Select---</option>
                <option :value="1">YES</option>
                <option :value="2">NO</option>
              </select>
            </div>
          </div>

          <div class="form-group form-row mb-1 w-100">
            <label for="pni-replacement" class="col-4 col-form-label pt-0 font-weight-bold">Success to Send Replacement
              :</label>
            <div class="col-8">
              <select class="form-control form-control-sm" id="pni-replacement"
                      :disabled="!editable"
                      v-model="pandi.replacement"
              >
                <option :value="null">---Select---</option>
                <option v-for="(replacementOption, index) in replacementOptions" :key="index"
                        :value="replacementOption"
                >{{ replacementOption }}
                </option>
              </select>
            </div>
          </div>

          <div class="form-group form-row mb-1 w-100">
            <label for="pni-rehire-plan" class="col-4 col-form-label pt-0 font-weight-bold">Plan to Rehire :</label>
            <div class="col-8">
              <select class="form-control form-control-sm" id="pni-rehire-plan"
                      :disabled="!editable"
                      v-model="pandi.rehire_plan"
              >
                <option :value="null">---Select---</option>
                <option v-for="(rehirePlan, index) in rehirePlans" :key="index"
                        :value="rehirePlan"
                >{{ rehirePlan }}
                </option>
              </select>
            </div>
          </div>

          <div class="form-group form-row mb-1 w-100">
            <label for="pni-club" class="col-4 col-form-label pt-0 font-weight-bolder">P&I Club :</label>
            <div class="col-8">
              <select class="form-control form-control-sm" id="pni-club"
                      v-model="pandi.pandi_club_id"
                      :disabled="!editable"
              >
                <option :value="null">--- SELECT P&i Club ---</option>
                <option v-for="pandiClubKey in pandiClubKeys"
                        :key="pandiClubKey.id"
                        :value="pandiClubKey.id"
                >{{ pandiClubKey.name }}
                </option>
              </select>
            </div>
          </div>

          <div class="form-group form-row mb-1 w-100">
            <label for="pni-local-correspondent" class="col-4 col-form-label pt-0 font-weight-bold">P&I Club Local
              Correspondent :</label>
            <div class="col-8">
              <select class="form-control form-control-sm" id="pni-local-correspondent"
                      :disabled="!editable"
                      v-model="pandi.local_correspondent"
              >
                <option :value="null">---Select---</option>
                <option v-for="(localCorrespndent, index) in localCorrespndents" :key="index"
                        :value="localCorrespndent"
                >{{ localCorrespndent }}
                </option>
              </select>
            </div>
          </div>

          <div class="form-group form-row mb-1 w-100">
            <label for="pni-deductible" class="col-4 col-form-label pt-0 font-weight-bold">Below Deductible</label>
            <div class="col-8">
              <select class="form-control form-control-sm" id="pni-deductible"
                      :disabled="!editable"
                      v-model="pandi.deductible"
              >
                <!--                <option :value="null">-&#45;&#45;Select-&#45;&#45;</option>-->
                <!--                <option v-for="(deductible, index) in deductibles" :key="index"-->
                <!--                        :value="index"-->
                <!--                >{{ deductible }}-->
                <!--                </option>-->
                <option :value="null">---Select---</option>
                <option :value="1">YES</option>
                <option :value="2">NO</option>

              </select>
            </div>
          </div>


          <!--          Add Expenses Button-->
          <div class="d-flex flex-row">
            <div class="p-2">
              <button type="button" class="btn btn-primary btn-sm btn-xs font-weight-bold mt-3"
                      @click="addPandiExpense"
                      v-if="editable"
              >
                <i class="fas fa-plus-circle mr-1"></i>Add Expenses
              </button>
            </div>
          </div>

          <div class="mb-2">
                    <span class="font-weight-bold" v-if="deletedExpensesWithExpenseIdOnly > 0">
                      Clicking <span class="text-warning"> <i class="fas fa-edit"></i> Update </span> will permanently remove
                      <span class="text-danger"> {{ deletedExpensesWithExpenseIdOnly }} </span>
                      record/s
                    </span>
          </div>


          <!--          Add expenses table table-->
          <div class=" table-responsive text-small mb-3">
            <table class="table table-hover table-bordered table-template-1 text-small sticky-header">
              <thead>
              <tr>
                <th class="col-type-width">Type</th>
                <th class="col-expense-width">Value</th>
                <th class="col-expense-width">Currency</th>
                <th style="width: 50px;" v-if="editable">Action</th>
                <th style="width: 50px;" v-if="editable"></th>
              </tr>
              </thead>
              <tbody>


              <tr v-for="(expense, index) in pandi.pandi_expenses" :key="index">
                <td>
                  <select class="form-control form-control-sm" id="pni-deductible"
                          style="font-size: 12px;"
                          :disabled="!editable"
                          v-model="expense.pandi_expense_type_id"
                  >
                    <option v-for="expenseType in pandiExpenseTypeKeys" :key="expenseType.id"
                            :value="expenseType.id"
                    >{{ expenseType.name }}
                    </option>

                  </select>
                </td>
                <td>
                  <template v-if="!editable">
                    <input type="text" name="" id="" :value="formatToMoney(expense.value)"
                           disabled
                           class="form-control form-control-sm form-control-xs px-lg-0 px-xl-2 text-center">
                  </template>
                  <input type="number" id="pni-days"
                         class="form-control form-control-sm form-control-xs px-lg-0 px-xl-2 text-center"
                         placeholder="Value"
                         style="font-size: 12px;"
                         v-else
                         v-model="expense.value"
                         @input="handleInput(expense.value)"
                  >
                </td>
                <td>
                  <select class="form-control form-control-sm" id="pni-deductible"
                          :disabled="!editable"
                          style="font-size: 12px;"
                          v-model="expense.currency_id"
                  >
                    <option v-for="currency in currencies" :key="currency.id" :value="currency.id">
                      {{ currency.name }}
                    </option>
                  </select>
                </td>
                <td class="text-center" v-if="editable">
                  <!--                  <input type="checkbox"-->
                  <!--                         class="btn btn-danger btn-sm btn-xs font-weight-bold"-->
                  <!--                         v-model="deletedExpenses"-->
                  <!--                         :value="expense.id"-->
                  <!--                  />-->
                  <!--                  @click="removePandiExpense(index, expense.id)"-->

                  <button type="button"
                          class="btn btn-outline-danger btn-sm btn-xs font-weight-bold"
                          @click="removePandiExpense(index, expense.id)"
                          :disabled="!editable"
                  >
                    <i class="fas fa-minus"></i>
                  </button>
                </td>

                <td class="text-center" v-if="editable">
                  <!--                      <button class="btn btn-sm btn-xs btn-outline-primary font-weight-bolder float-right"-->
                  <!--                              data-toggle="modal" data-target="#add-attachment"-->
                  <!--                      >-->
                  <!--                        <span class="fas fa-plus"></span>-->
                  <!--                        Add-->
                  <!--                      </button>-->

                  <button type="button"
                          class="btn btn-outline-primary btn-sm btn-xs font-weight-bold"
                          data-toggle="modal"
                          data-target="#view-attachments-modal"
                          @click="getExpenseDetails(expense.pandi_attachments, expense.id)"
                          v-if="expense.id"
                  >
                    VIEW
                  </button>
                </td>
              </tr>

              <tr v-if="pandi.pandi_expenses ? (pandi.pandi_expenses.length == 0) : '' ">
                <td colspan="100%" class="bg-light-danger font-weight-bolder">
                  <p class="text-center mt-3">No result detected</p>
                </td>
              </tr>

              </tbody>

            </table>


            <!-- ================================================ Modal for Attachments ================================================ -->
            <div class="modal fade" id="view-attachments-modal" tabindex="-1" role="dialog"
                 aria-labelledby="view-attachments-modal-title"
                 aria-hidden="true" data-backdrop="static" data-keyboard="false">
              <div class="modal-dialog modal-dialog-centered" role="document"
              >
                <div class="modal-content"
                >
                  <div class="modal-header">

                    <div class="form-inline">
                      <div class="form-group mb-2 ">
                        <h5 class="modal-title font-weight-bolder mr-3" id="view-attachments-modal-title">
                          Attachment List
                        </h5>
                      </div>
                      <div class="form-group mx-sm-3 mt-2 mb-2">
                        <template v-if="crew.active == 1 || isSystemAdmin">
                          <button type="button" class="btn btn-warning btn-sm btn-xs font-weight-bold mb-2 mr-2"
                                  v-show="!editableAttachment"
                                  v-if="isDesignatedManning || isManningAdmin || isManning || isPrincipal || isDesignatedPrincipal || isPrincipalStaff"
                                  @click="editAttachment"
                          >
                            <i class="fas fa-edit"></i>
                            Edit
                          </button>

                          <button type="submit" class="btn btn-success btn-sm btn-xs font-weight-bold mb-2 mr-2"
                                  v-show="editableAttachment"
                                  @click="confirmUpdatePandi"
                          >
                            <i class="fas fa-edit"></i>
                            Save
                          </button>


                          <button type="button" class="btn btn-outline-danger btn-sm btn-xs font-weight-bold mb-2 mr-2"
                                  @click="cancelEditAttachment"
                                  v-show="editableAttachment"
                          >
                            <i class="fas fa-ban"></i>
                            Cancel
                          </button>
                        </template>
                      </div>

                    </div>


                    <button type="button" id="close-view-attachments-modal" class="close"
                            @click="closeModal"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>


                  <div class="modal-body text-small">

                    <div class="mb-2">
                    <span class="font-weight-bold" v-if="deletedFileAttachments.length > 0">
                      Clicking <span class="text-success"> <i class="fas fa-edit"></i> Save </span> will permanently remove
                      <span class="text-danger"> {{ deletedFileAttachments.length }} </span>
                      record/s
                    </span>
                    </div>


                    <div class=" table-responsive text-small mb-3">
                      <table class="table table-hover table-bordered table-template-1 text-small sticky-header">
                        <thead>
                        <tr>
                          <th class="col-type-width">Attachment Name</th>
                          <th>File</th>
                          <th v-if="editableAttachment"></th>
                        </tr>
                        </thead>

                        <tbody>

                        <tr v-for="(expenseAttachment, index) in viewExpenseAttachments"
                            :key="index">

                          <td style="text-align: center;">
                            <span class="bg-light-danger font-weight-bolder">{{ expenseAttachment.name }}</span>
                          </td>
                          <td style="text-align: center;">
                            <a type="button" class="text-primary"
                               title="View Attachment"
                               @click="loadIncidentAttachmentFile(expenseAttachment.id, index, expenseAttachment.name)"
                            >View File</a>
                          </td>
                          <td style="text-align: center;" v-if="editableAttachment">
                            <button type="button"
                                    class="btn btn-outline-danger btn-sm btn-xs font-weight-bold"
                                    @click="deleteFileAttachment(index, expenseAttachment.id)"
                                    :disabled="!editableAttachment"
                            >
                              <!--                    <i class="fas fa-minus"></i>-->
                              ✖
                            </button>
                          </td>
                        </tr>

                        <tr v-if="viewExpenseAttachments ? (viewExpenseAttachments.length == 0) : '' ">
                          <td colspan="100%" class="bg-light-danger font-weight-bolder">
                            <p class="text-center mt-3">No attachments found</p>
                          </td>
                        </tr>

                        </tbody>
                      </table>

                    </div>

                    <!--          Add Expense Attachment with remove all button-->
                    <div class="d-flex justify-content-end">
                      <template v-if="addedAttachments.length">
                        <button type="button"
                                class="btn btn-outline-danger btn-sm btn-xs border-0 p-1 mr-3 mb-3 font-weight-bold"
                                @click="removeAllAttachments"
                                v-if="editableAttachment"
                        >
                          <i class="fas fa-minus-circle"></i> Remove All
                        </button>
                      </template>

                      <button type="button" class="btn btn-primary btn-sm btn-xs mb-3 font-weight-bold"
                              @click="addAttachment"
                              v-if="editableAttachment"
                      >
                        <i class="fas fa-plus-circle mr-1"></i>Add Attachment/s
                      </button>

                    </div>


                    <div class="addScroll">
                      <!--          Add expense attachment -->
                      <div v-if="editableAttachment">
                        <!--                original class = d-flex justify-content-center form-group row mb-2 py-2 bg-light border-top-->
                        <div class="d-flex justify-content-center form-group bg-light py-2"
                             v-for="(attachment, index) in addedAttachments" :key="index">
                          <div class="col-sm-8 mb-2">
                            <button type="button"
                                    class="float-right btn btn-outline-danger btn-sm btn-xs font-weight-bold mb-1"
                                    @click="removeAttachment(index)"
                            >
                              ✖
                            </button>

                            <input type="text"
                                   class="form-control mb-1"
                                   placeholder="Enter attachment name"
                                   v-model="attachment.name">

                            <div class="custom-file form-control-sm">
                              <input type="file" class="custom-file-input"
                                     :id="'attachment' + index" required
                                     accept="application/pdf"
                                     @change="updateFileLabel(index)"
                              >
                              <label class="custom-file-label"
                                     :for="'attachment' + index"
                                     :id="'label' + index"
                              >Choose file</label>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>


                  </div>

                </div>
              </div>
            </div>
            <!-- ================================================ Modal for Attachments ================================================ -->

          </div>


          <!-- two rows-->
          <!--          <div class="form-group form-row mb-1 w-100">-->
          <!--            <div class="col-6">-->

          <!--            </div>-->

          <!--            <div class="col-6">-->
          <!--              -->
          <!--            </div>-->
          <!--          </div>-->


          <!--          Total Expenses Table-->
          <div class=" table-responsive text-small mb-3">
            <table class="table table-hover table-bordered table-template-1 text-small sticky-header">
              <thead>
              <tr>
                <th class="col-type-width">Currency</th>
                <th>Total Expense</th>
              </tr>
              </thead>
              <tbody>

                <template v-if="pandi.expensesPerCurrency">
                  <tr :key="currency.id" v-for="currency in pandi.expensesPerCurrency">
                    <td style="text-align: center;">
                      <span class="bg-light-danger font-weight-bolder">{{currency.currency}}</span>
                    </td>
                    <td class="text-center">
                      <span>{{currency.amount}}</span>
                    </td>
                  </tr>
                </template>
              </tbody>

            </table>
          </div>


          <!--          <div class="form-group form-row mb-1 w-100">-->
          <!--            <label for="pni-total-expense" class="col-4 col-form-label pt-0 font-weight-bold">Total Expense :</label>-->
          <!--            <div class="col-8">-->
          <!--                            <textarea class="form-control form-control-sm" id="pni-total-expense" rows="5"-->
          <!--                                      :readonly="!editable"-->
          <!--                                      v-model="pandi.total_expense"-->
          <!--                            ></textarea>-->
          <!--            </div>-->
          <!--          </div>-->

          <div class="form-group form-row mb-1 w-100 mt-5">
            <label for="pni-total-expense" class="col-4 col-form-label pt-0 font-weight-bold">Status Remarks :</label>
            <div class="col-8">
                            <textarea class="form-control form-control-sm" id="pni-total-expense" rows="5"
                                      :readonly="!editable"
                                      v-model="pandi.status_remarks"
                            ></textarea>
            </div>
          </div>

          <!--          <div class="form-group form-row mb-1 w-100">-->
          <!--            <label for="pni-currency" class="col-4 col-form-label pt-0 font-weight-bold">Currency</label>-->

          <!--            <div class="col-8">-->
          <!--              <select class="form-control form-control-sm" id="pni-currency"-->
          <!--                      :disabled="!editable"-->
          <!--                      v-model="pandi.currency_id"-->
          <!--              >-->
          <!--                <option :value="null">-&#45;&#45;Select Currency-&#45;&#45;</option>-->
          <!--                <option v-for="currency in currencies" :key="currency.id" :value="currency.id">-->
          <!--                  {{ currency.name }}-->
          <!--                </option>-->
          <!--              </select>-->
          <!--            </div>-->
          <!--          </div>-->

          <div class="form-group form-row mb-1 w-100">
            <label for="pni-disembark-date" class="col-4 col-form-label pt-0 font-weight-bold">Disembark Date:</label>
            <div class="col-8">
              <input type="date" id="pni-disembark-date"
                     class="form-control form-control-sm w-100"
                     :readonly="!editable"
                     v-model="pandi.date_disembark"
              >
            </div>
          </div>

          <div class="form-group form-row mb-1 w-100">
            <label for="pni-endorsement" class="col-4 col-form-label pt-0 font-weight-bold">Endorsement Date :</label>
            <div class="col-8">
              <input type="date" id="pni-endorsement"
                     class="form-control form-control-sm w-100"
                     :readonly="!editable"
                     v-model="pandi.endorsement"
              >
            </div>
          </div>

          <div class="form-group form-row mb-1 w-100">
            <label for="pni-result" class="col-4 col-form-label pt-0 font-weight-bolder">Final Result/Status :</label>
            <div class="col-8">
              <select class="form-control form-control-sm" id="pni-result"
                      v-model="pandi.pandi_result_id"
                      :disabled="!editable"
              >
                <option :value="null">--- SELECT RESULT ---</option>
                <option v-for="pandiResultKey in pandiResultKeys"
                        :key="pandiResultKey.id"
                        :value="pandiResultKey.id"
                >{{ pandiResultKey.name }}
                </option>
              </select>
            </div>
          </div>

          <div class="form-group form-row mb-1 w-100">
            <label for="pni-status" class="col-4 col-form-label pt-0 font-weight-bold">Case Status :</label>
            <div class="col-8">
              <select class="form-control form-control-sm" id="pni-status"
                      v-model="pandi.active"
                      :disabled="!editable"
              >
                <option :value="1">ACTIVE</option>
                <option :value="0">CLOSED</option>
              </select>
            </div>
          </div>


          <!--                    <div class="text-right" slot="heading">-->
          <!--                        <button type="submit" class="btn btn-warning btn-sm btn-xs font-weight-bold mb-2 mr-2"-->
          <!--                                v-if="isDesignatedManning"-->
          <!--                        >-->
          <!--                            <i class="fas fa-edit"></i>-->
          <!--                            {{ editable ? 'Update' : 'Edit' }}-->
          <!--                        </button>-->

          <!--                        <button type="reset" class="btn btn-outline-danger btn-sm btn-xs font-weight-bold mb-2 mr-2"-->
          <!--                                @click="cancelEdit"-->
          <!--                                v-if="editable"-->
          <!--                        >-->
          <!--                            <i class="fas fa-ban"></i>-->
          <!--                            Cancel-->
          <!--                        </button>-->
          <!--                    </div>-->

        </form>
      </div>
      <pandi-checkup-index :pandi="viewPandi"></pandi-checkup-index>

    </div>
    <div class="float-left" slot="heading">
      <template v-if="(crew.active == 1 || isSystemAdmin) && !guest">
        <button type="submit" class="btn btn-warning btn-sm btn-xs font-weight-bold mb-2 mr-2"
                v-if="isDesignatedManning || isManning || isManningAdmin || isDesignatedPrincipal || isPrincipal || isPrincipalStaff"
                @click="confirmUpdatePandi"
        >
          <i class="fas fa-edit"></i>
          {{ editable ? 'Update' : 'Edit' }}
        </button>
      </template>

      <button type="reset" class="btn btn-outline-danger btn-sm btn-xs font-weight-bold mb-2 mr-2"
              @click="cancelEdit"
              v-if="editable"
      >
        <i class="fas fa-ban"></i>
        Cancel
      </button>
    </div>
  </cms-modal2>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {vueAppMixin} from "@/mixins/vueAppMixin";
import {formMixin} from "@/mixins/formMixin";
import {dataMixin} from "@/mixins/dataMixin";
import {gateMixin} from "@/mixins/gateMixin";

import CmsModal2 from "@/components/elements/CmsModal2";
import PandiCheckupIndex from "./PandiCheckupIndex";
import {ObjectService} from "@/services/Utilities/ObjectService";
import Swal from "sweetalert2";

export default {
  name: "ViewPandi",

  mixins: [vueAppMixin, formMixin, dataMixin, gateMixin],

  components: {CmsModal2, PandiCheckupIndex},

  props: {
    viewPandi: {
      type: Object,
      default() {
        return {};
      }
    },

    defaultValues: {
      type: Array,
      default() {
        return {};
      }
    },
  },

  data() {
    return {
      viewExpenseAttachments: {},
      viewExpenseAttachmentsCopy: {},

      pandiExpenseId: null,
      pandiCopy: {},

      addedAttachments: [],
      deletedExpenses: [],
      deletedFileAttachments: [],

      // is used throughout view pandi
      pandi: {},

      defaultPandi: [],
      pandiError: {},
      editable: false,
      editableAttachment: false,
      editableFields: [
        'id',
        'code',
        'endorsement',
        'pandi_result_id',
        'pandi_club_id',
        'finish_contract',
        'discharge',
        'replacement',
        'rehire_plan',
        'local_correspondent',
        'deductible',
        'total_expense',
        'status_remarks',
        'currency_id',
        'date_disembark',
        'active',
        'pandi_expenses',
      ],
      newCheckupReport: {},
      tempCheckupReport: {},
      pandiCheckupErrors: {},
      checkupReportOrig: {},
      checkupReportFile: '',
      replacementOptions: [
        'YES', 'NO', 'VESSEL CHANGE MANAGEMENT'
      ],

      rehirePlans: [
        'N/A', 'REHIRE', 'FOR MGMT ASSESSMENT', 'ON-GOING'
      ],

      localCorrespndents: [
        'PANDIMAN', 'PANDIPHIL'
      ],

      deductibles: [
        'NO', 'YES'
      ],
    }
  },

  methods: {
    ...mapActions([
      'updatePandi',
      'getCurrencies',
      'getPandiExpenseTypeKeys',
      'getPandiExpenseAttachmentFile',
    ]),


    async confirmUpdatePandi() {
      console.log(this.deletedExpenses, 'deletedFileAttachments')

      if (this.editable) {
        if (await this.confirmUpdate()) {

          let formData = new FormData();

          // Pandi Editables
          let params = {};
          let sanitizedObjectData = this.sanitizeObjectData(this.editableFields, this.pandi, true);
          Object.keys(sanitizedObjectData).forEach(key => {
            params[key] = sanitizedObjectData[key];
          });

          Object.keys(params).forEach(key => {
            let value = params[key] ? params[key] : '';
            formData.append(key, value);
          });


          // Added Expenses
          let addedExpenses = [];
          Object.assign(this.pandi.pandi_expenses).forEach((val, index) => {
            addedExpenses.push(val);
          })
          addedExpenses.map(v => Object.assign(v, {pandi_id: this.pandi.id}))
          // Object.assign(params, {pandi_expenses: addedExpenses});
          Object.assign(params, {pandi_deleted: this.deletedExpenses});

          // append added Expenses
          formData.append('addedExpenses', JSON.stringify(addedExpenses))
          // append deleted Expenses
          formData.append('deletedExpenses', JSON.stringify(this.deletedExpenses))


          // append added attachments
          this.addedAttachments.forEach((addedAttachments, index) => {
            let attachment = document.getElementById(`attachment` + index);
            if (attachment.files && attachment.files[0]) {
              let file = attachment.files[0];
              formData.append(`attachment` + index, file);
            }
          });

          // append added Attachments
          formData.append('addedAttachments', JSON.stringify(this.addedAttachments));

          // append deleted Attachments
          formData.append('deletedFileAttachments', JSON.stringify(this.deletedFileAttachments));

          // Update Pandi ACTION
          let updatedPandi = await this.updatePandi(formData);

          if (updatedPandi) {
            if (updatedPandi.errors) {
              if (updatedPandi.errors.pandi_expense !== undefined) {
                Swal.fire({
                  'title': 'PANDI EXPENSE ERROR',
                  'width': '600px',
                  // showCancelButton: true,
                  // cancelButtonText: 'Cancel',
                  cancelButtonColor: '#dc3545',
                  confirmButtonColor: '#28a745',
                  'html': `<div class="container">
                       <h6 class="text-center mb-3">
                           Kindly check if each of expenses are fulfilled
                       </h6>
                        <ul class="list-unstyled text-left pl-4">
                            <li>Type is selected</li>
                            <li>Value is filled</li>
                            <li>Value is greater than 0</li>
                            <li>Currency is selected</li>
                        </ul>
                     </div>`
                })
              }
              this.pandiError = updatedPandi.errors;

            } else {
              this.successAlert('P&I Details Successfully Updated', 'UPDATE');
              // document.getElementById('close-view-pandi').click();
              // document.getElementById('close-view-attachments-modal').click();

              // Clear values for added attachments after add
              this.addedAttachments.splice(0, this.addedAttachments.length);
              this.deletedFileAttachments = [];

              // emits updated data to the parent "pandis" in PandI.vue
              this.$emit("updated-data-from-view-pandi", this.pandisCopy);
              this.pandiError = {};
              this.editable = false;

              const countCurrentAttachments = this.pandi.pandi_expense_attachments.length
              const sliced = this.pandisCopy.pandi_expense_attachments.slice(countCurrentAttachments);

              Array.prototype.push.apply(this.viewExpenseAttachments, sliced);

              this.viewExpenseAttachmentsCopy = JSON.parse(JSON.stringify(this.viewExpenseAttachments));


            }
          } else {
            this.errorAlert('P&I Details Failed to Update', 'UPDATE');
          }
        }
      } else {
        this.editable = true;
      }
    },

    cancelEdit() {
      this.pandi = JSON.parse(JSON.stringify(this.viewPandi));
      // this.pandiCopy = JSON.parse(JSON.stringify(this.viewPandi));
      this.editable = false;
      this.editableAttachment = false;
      this.pandiExpenseId = null;
      this.deletedFileAttachments = [];
      this.deletedExpenses = [];
      this.addedAttachments.splice(0, this.addedAttachments.length);
    },

    getFieldValues() {
      // for (let key of Object.keys(this.values)) {
      //   console.log(key + " -> " + this.values[key])
      // }
      // console.log(this.phoneNumbers);
    },


    addPandiExpense() {
      this.pandi.pandi_expenses.push({
        id: null,
        pandi_expense_type_id: null,
        value: null,
        currency_id: null,
      });
    },

    removePandiExpense(index, expenseId) {
      this.deletedExpenses.push({
        expenseId: expenseId,
      });

      // when spliced, it is also removed from this.pandi therefore cancel cannot bring back the previous
      // unless reloaded
      this.pandi.pandi_expenses.splice(index, 1);

    },


    deleteFileAttachment(index, attachmentId) {
      this.deletedFileAttachments.push({
        pandiAttachmentId: attachmentId,
      });

      this.viewExpenseAttachments.splice(index, 1);

    },


    // async deleteFileAttachment(index, attachmentId) {
    //
    //   if (await this.confirmDeleteAlert()) {
    //     if (await this.confirmUpdatePandi())
    //
    //
    //     this.deletedFileAttachments.push({
    //       pandiAttachmentId: attachmentId,
    //     });
    //
    //     // add splice everything in deletedFileAttachments
    //     this.viewExpenseAttachments.splice(index, 1);
    //
    //   }
    //
    // },


    addAttachment() {
      this.addedAttachments.push({
        id: this.pandi.id,
        pandi_expense_id: this.pandiExpenseId,
        name: '',
      });
    },

    removeAttachment(index) {
      this.addedAttachments.splice(index, 1);
    },

    removeAllAttachments() {
      this.addedAttachments.splice(0, this.addedAttachments.length);
    },

    updateFileLabel(index) {
      let fileInput = document.getElementById('attachment' + index);
      let fileLabel = document.getElementById('label' + index);
      let labelText = 'Choose File';
      if (fileInput.files && fileInput.files[0]) {
        let file = fileInput.files[0];
        labelText = file.name;
      }
      fileLabel.innerHTML = labelText;
    },

    handleInput(value) {
      let val = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      // console.log(val)
    },


    async loadIncidentAttachmentFile(pandiExpenseAttachmentId, attachmentIndex, name) {
      let params = {
        pandiAttachmentId: pandiExpenseAttachmentId
      }
      let pandiExpenseAttachmentFile = await this.getPandiExpenseAttachmentFile(params);
      if (pandiExpenseAttachmentFile) {
        this.pdfViewer(name, pandiExpenseAttachmentFile);
        // this.pdfViewer(`${name} ${attachmentIndex + 1} FILE`, pandiExpenseAttachmentFile);
      }

      // console.log(pandiExpenseAttachmentFile);
    },

    getExpenseDetails(attachments, expenseId) {
      this.viewExpenseAttachments = attachments;
      this.viewExpenseAttachmentsCopy = JSON.parse(JSON.stringify(attachments));
      this.pandiCopy = JSON.parse(JSON.stringify(this.viewPandi));
      this.pandiExpenseId = expenseId;
    },

    editAttachment() {
      this.editableAttachment = true;
    },

    cancelEditAttachment() {
      this.viewExpenseAttachments = JSON.parse(JSON.stringify(this.viewExpenseAttachmentsCopy));
      // this.viewExpenseAttachments = this.pandisCopy.pandi_expense_attachments;
      this.pandi = JSON.parse(JSON.stringify(this.viewPandi));
      this.editableAttachment = false;
      this.deletedFileAttachments = [];
      this.addedAttachments.splice(0, this.addedAttachments.length);

      // console.log(this.viewExpenseAttachments, 'this.viewExpenseAttachments')
      // console.log(this.viewExpenseAttachmentsCopy, 'this.viewExpenseAttachmentsCopy')
    },

    closeModal() {
      $('#view-attachments-modal').modal('hide');
      this.cancelEditAttachment();
    },
    formatToMoney(amount) {
      return Number(amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
    }

  },

  computed: {
    ...mapGetters([
      'pandiClubKeys',
      'pandiResultKeys',
      'pandiCheckups',
      'currencies',
      'pandisCopy',
      'pandiExpenseTypeKeys',
    ]),

    totalDays() {
      if (!this.pandiCheckups.length) return 0;
      let totalDays = 0;
      let latestCheckupDate = ObjectService.findMax(this.pandiCheckups, 'checkup_date');
      let dateFrom = this.pandi.endorsement;
      let dateTo = latestCheckupDate.checkup_date;
      if (dateFrom && dateTo) totalDays = this.dateDiff(dateTo, dateFrom);
      return totalDays;
    },

    // eslint-disable-next-line vue/return-in-computed-property
    ph_total_expenses() {
      if (this.pandi.ph_total_expenses) {
        return Number(parseFloat(this.pandi.ph_total_expenses).toFixed(2)).toLocaleString('en', {
          minimumFractionDigits: 2
        });
      }
    },

    // eslint-disable-next-line vue/return-in-computed-property
    us_total_expenses() {
      if (this.pandi.us_total_expenses) {
        return Number(parseFloat(this.pandi.us_total_expenses).toFixed(2)).toLocaleString('en', {
          minimumFractionDigits: 2
        });

      }
    },

    deletedExpensesWithExpenseIdOnly() {
      return this.deletedExpenses.filter(record => record.expenseId !== null).length;
    }

  },

  created() {
    this.getCurrencies();
    this.getPandiExpenseTypeKeys();
  },

  watch: {
    viewPandi() {
      // puts a perfect copy of viewPandi inside pandi
      this.pandi = JSON.parse(JSON.stringify(this.viewPandi));
      // this.pandi = Object.assign({}, this.viewPandi);
      this.editable = false;
      let newArray = this.defaultValues.slice();
    },

    // pandisCopy(){
    //   this.pandiLatest = Object.assign({}, this.pandisCopy);
    // }


  }

}
</script>

<style scoped>

input {
  height: 3vh !important;
}

.col-expense-width {
  width: 150px !important;
}

.col-type-width {
  width: 160px;
  word-wrap: break-spaces;
}

.addScroll {
  overflow-y: auto;
  height: 350px;
}


</style>
